import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import {
  DataTable,
  DataTablePageEvent,
  DataTableRowClickEvent,
  DataTableSortEvent,
} from "primereact/datatable";
import { Column } from "primereact/column";
import { Button } from "primereact/button";
import { useChecklists } from "../../api/queries/checklists/useChecklists";
import { Checklist } from "../../api/types/checklist";
import {
  formatDateTime,
  parseQueryString,
  toQueryString,
} from "../../common/utils";

export default function ChecklistList() {
  const navigate = useNavigate();
  const limit = 20;
  const queryParams = parseQueryString(useLocation().search);

  const [offset, setOffset] = useState(0);
  const [total, setTotal] = useState(0);
  const [sortField, setSortField] = useState(queryParams.sortField);
  const [sortOrder, setSortOrder] = useState(queryParams.sortOrder);

  const onPage = ({ first }: DataTablePageEvent) => setOffset(first);
  const onSort = (event: DataTableSortEvent) => {
    setSortField(event.sortField);
    setSortOrder(event.sortOrder);
  };

  const { data: checklists, isLoading } = useChecklists({
    limit,
    offset,
  });

  const onRowClick = (event: DataTableRowClickEvent) =>
    navigate(`/checklists/${event.data.id}`);

  const tName = (row: Checklist) => row.name;

  const tStages = (row: Checklist) => row.checklist_stages.length;

  const tCreatedAt = (row: Checklist) => formatDateTime(row.created_at);

  const tIsDefault = (row: Checklist) => (
    <i className={row.is_default ? "fa fa-check" : "fa fa-times"} />
  );

  useEffect(() => {
    const queryParamsStr = toQueryString({
      limit: 20,
      offset,
      sortField,
      sortOrder,
    });
    navigate({ search: queryParamsStr });
  }, [offset, navigate, sortField, sortOrder]);

  useEffect(() => {
    if (checklists) {
      setTotal(checklists.data.total_count);
    }
  }, [checklists]);

  return (
    <div className={"col-12"}>
      <div className="flex py-3">
        <h1 className="m-0">Checklist</h1>

        <Button
          onClick={() => navigate("/checklists/new")}
          className="p-button p-button-main p-button-sm ml-auto"
          label="Add new"
        />
      </div>

      <DataTable
        emptyMessage={"No records"}
        paginator={true}
        lazy={true}
        rows={20}
        first={offset}
        totalRecords={total}
        loading={isLoading}
        sortField={sortField}
        sortOrder={sortOrder}
        onPage={onPage}
        onSort={onSort}
        value={checklists?.data.results || []}
        className="p-datatable-sm p-datatable-pointer"
        onRowClick={onRowClick}
        stripedRows={true}
      >
        <Column header={"Name"} body={tName} />

        <Column header={"Stages"} body={tStages} />

        <Column header={"Created at"} body={tCreatedAt} />

        <Column header={"Default"} body={tIsDefault} />
      </DataTable>
    </div>
  );
}
